import { useZero } from '@rocicorp/zero/react'
import { toast } from '@saas-ui/react'

import { InviteDialog } from '@trevize/ui/invite-dialog'

import { awaitServerMutation } from '#zero/await-server-mutation.ts'
import { mutators } from '#zero/mutators.ts'

import { useCurrentWorkspace } from '../hooks/use-current-workspace'

export function InvitePeopleDialog(props: {
  isOpen: boolean
  onClose: () => void
}) {
  const [workspace] = useCurrentWorkspace()
  const zero = useZero()

  return (
    <InviteDialog
      {...props}
      onInvite={async ({ emails, role }) => {
        const result = await toast.promise(
          awaitServerMutation(
            zero.mutate(
              mutators.workspaceMembers.invite({
                workspaceId: workspace.id,
                emails,
                role,
              }),
            ),
          ),
          {
            loading: {
              title:
                emails.length === 1
                  ? `Inviting ${emails[0]}...`
                  : `Inviting ${emails.length} people...`,
            },

            success: () => {
              return {
                title: 'Invitation(s) have been sent.',
              }
            },
            error: (error) => {
              console.error(error)
              return {
                title: 'Failed to invite people',
              }
            },
          },
        )

        if (!result) {
          throw new Error('Failed to invite people')
        }
      }}
    />
  )
}
